import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { Typography } from "@mui/material";
import { FormControlLabel } from "@material-ui/core";

import CheckboxComponent from "../common/Checkbox";
import {
  selectDisplayGradientOnGrid,
  selectIsHeatMapGradientOnGridFeatureEnabled,
} from "../../store/heatmap/HeatMapSelectors";
import { setDisplayGradientOnGrid } from "../../store/heatmap/HeatMapActions";
import {
  StyledCheckboxRow,
  StyledConfigSection,
} from "./HeatMapModalStyles";

/**
 * "Additional Options" section in the heat map config panel — currently
 * a single checkbox that toggles the per-tile heat map gradient bar on
 * the catalog grid. The flag persists across modal close (along with
 * the metric / colors / date range that drive the color) so the grid
 * keeps painting until the user explicitly turns it off.
 */
const HeatMapAdditionalOptions: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const checked = useSelector(selectDisplayGradientOnGrid);
  const isFeatureEnabled = useSelector(
    selectIsHeatMapGradientOnGridFeatureEnabled,
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setDisplayGradientOnGrid(event.target.checked));
  };

  if (!isFeatureEnabled) return null;

  return (
    <StyledConfigSection>
      <Typography variant="heading" className="heatmap-section-label">
        {intl.formatMessage({
          id: "heatMap.additionalOptionsLabel",
          defaultMessage: "Additional Options",
        })}
      </Typography>

      <StyledCheckboxRow>
        <FormControlLabel
          control={
            <CheckboxComponent
              checkboxId="HeatMapGradientGrid"
              checked={checked}
              onChange={handleChange}
            />
          }
          label={
            <Typography variant="subtitle2">
              {intl.formatMessage({
                id: "heatMap.displayGradientOnGrid",
                defaultMessage: "Display Heat Map Gradient on Grid",
              })}
            </Typography>
          }
        />
      </StyledCheckboxRow>
    </StyledConfigSection>
  );
};

export default HeatMapAdditionalOptions;
